import React from "react";
import ProcessImg from "../images/Process.jpg";
import "../css/Process.css";

function Process() {
  return (
    <>
      <div className="Process" style={{ marginTop: "180px" }}>
        <p className="Process-p">Work Process</p>
        <p className="Process-p1">
          Our work process delivers services and solutions designed to enhance
          business outcomes and drive measurable results.
        </p>
        <img className="Process-img" src={ProcessImg} alt="" />
      </div>
    </>
  );
}

export default Process;
